export default () => ({
    require: '?ngModel',
    link(scope, element, attrs, ngModelCtrl) {
        if (!ngModelCtrl) {
            return;
        }

        ngModelCtrl.$formatters.push(v => +parseFloat(v || '0').toFixed(isFinite(attrs.precision) ? attrs.precision : 2));

        ngModelCtrl.$parsers.push(function (val) {
            if (angular.isUndefined(val)) {
                var val = '';
            }
            var clean = val.toString().replace(/[^0-9\.]/g, '');
            var decimalCheck = clean.split('.');

            if (!angular.isUndefined(decimalCheck[1])) {
                decimalCheck[1] = decimalCheck[1].slice(0, isFinite(attrs.precision) ? attrs.precision : 2);
                clean = decimalCheck[0] + '.' + decimalCheck[1];
            }

            if (val !== clean) {
                ngModelCtrl.$setViewValue(clean);
                ngModelCtrl.$render();
            }
            return clean;
        });

        element.bind('keypress', function (event) {
            if (event.keyCode === 32) {
                event.preventDefault();
            }
        });
    }
});